import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export const LoadingSpinner = ({ fullPage = false, size = 40, height = "auto" }) => {
  return (
    <Box
      sx={{
        // mt: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: fullPage ? "100vh" : height,
        width: "100%",
        color: 'RGBA(0, 0, 0, 0.6)',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};




// import React from "react";
// import CircularProgress from "@mui/material/CircularProgress";
// import Box from "@mui/material/Box";
// import { keyframes } from "@mui/system";

// // Define a keyframe animation for smooth rotation and color change
// const colorCycle = keyframes`
//   0% {
//     stroke: #ff0000;
//   }
//   25% {
//     stroke: #00ff00;
//   }
//   50% {
//     stroke: #0000ff;
//   }
//   75% {
//     stroke: #ff00ff;
//   }
//   100% {
//     stroke: #ff0000;
//   }
// `;

// const rotate = keyframes`
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//   }
// `;

// export const LoadingSpinner = ({
//   fullPage = false,
//   size = 90,
//   height = "auto",
// }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: fullPage ? "100vh" : height,
//         width: "100%",
//         animation: `${rotate} 2s linear infinite`,
//       }}
//     >
//       <CircularProgress
//         size={size}
//         thickness={5}
//         sx={{
//           mt:10,
//           animation: `${colorCycle} 4s linear infinite`,
//           // Override the svg circle stroke color with the CSS animation
//           svg: {
//             transformOrigin: "50% 50%",
//           },
//           circle: {
//             strokeDasharray: "80, 100",
//             strokeLinecap: "round",
//           },
//         }}
//       />
//     </Box>
//   );
// };
